import { Subtitle } from "core/models";

const alwaysTripleDigits = (n: number): string => {
    if (n < 10) {
        return `00${n}`;
    }
    if (n >= 10 && n < 100) {
        return `0${n}`;
    }
    if (n >= 1000) {
        return n.toString().slice(0, 3);
    }
    return n.toString();
};

export const convertTimefloatToTimecode = (
    timeFloat: number,
    separator = ".",
): string => {
    if (Number.isNaN(timeFloat)) {
        return "";
    }
    const hhmmss = new Date(timeFloat * 1000).toISOString().substr(11, 8);
    const msModulus =
        (Math.abs(timeFloat) * 10 - Math.floor(timeFloat) * 10) / 10;
    const ms = Math.floor(msModulus * 1000);
    return `${hhmmss}${separator}${alwaysTripleDigits(ms)}`;
};

export const createVtt = (subtitles: Subtitle[]): string => {
    let content = "WEBVTT\r\n";
    content += "\r\n";
    subtitles.forEach((subtitle) => {
        if (subtitle.error || subtitle.text.length === 0) {
            return;
        }
        content += `${convertTimefloatToTimecode(
            subtitle.startTime,
        )} --> ${convertTimefloatToTimecode(subtitle.endTime)}\r\n`;
        content += `${subtitle.text}\r\n`;
        content += "\r\n";
    });
    return content;
};

export const createSrt = (subtitles: Subtitle[]): string => {
    let content = "";
    subtitles.forEach((subtitle, index) => {
        if (subtitle.error || subtitle.text.length === 0) {
            return;
        }
        content += `${index}\r\n`;
        content += `${convertTimefloatToTimecode(
            subtitle.startTime,
            ",",
        )} --> ${convertTimefloatToTimecode(subtitle.endTime, ",")}\r\n`;
        content += `${subtitle.text}\r\n`;
        content += "\r\n";
    });
    return content;
};
